module.exports = __webpack_public_path__ + "img/levelSpacingWhite.a57a5098.svg";